import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    [theme.breakpoints.down("md")]: {
      marginBottom: 50,
    },
    // height: "100%",
    height: "calc(100vh - 115px)",
    overflow: "scroll !important",
  },
  activeAgent: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  pendingChatsAgent: {
    gridColumnStart: 1,
    gridColumnEnd: 5,
  },
  pendingChats: {
    gridColumnStart: 3,
    gridColumnEnd: 5,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  agentView: {
    gridColumnStart: 1,
    gridColumnEnd: 5,
  },
  facebookChats: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  whatsappChats: {
    gridColumnStart: 3,
    gridColumnEnd: 5,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  graphData: {
    gridColumnStart: 1,
    gridColumnEnd: 4,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  chatStatistics: {
    gridColumnStart: 4,
    gridColumnEnd: 5,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  pagesBreakdownGraph: {
    gridColumnStart: 1,
    gridColumnEnd: 4,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
  pagesBreakdownGraphList: {
    gridColumnStart: 4,
    gridColumnEnd: 5,
    [theme.breakpoints.down("sm")]: {
      gridColumnStart: 1,
      gridColumnEnd: 5,
    },
  },
}));

export default useStyles;
